import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getEnabledCampList, getEnabledTermList, getEnabledColumnList, saveUser, getExportList } from '@/api/student';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.form = {
            type: 1,
            courseId: '',
            keywordType: 1,
            keyword: '',
            source: 1,
        };
        this.chooseType = '1';
        this.columnList = [];
        this.exportList = [];
        this.props = {
            lazy: true,
            lazyLoad: async (node, resolve) => {
                const { level } = node;
                if (level <= 1) {
                    let nodes = level == 0 ? await this.getCampList() : await this.getTermList(node.value);
                    resolve(nodes);
                }
                else {
                    resolve([]);
                }
            }
        };
    }
    created() {
        if (this.$route.query.courseId) {
            this.form.courseId = this.$route.query.courseId;
            this.form.source = 2;
            this.form.type = 2;
        }
        else {
            this.getColumnList();
        }
    }
    async getCampList() {
        let res = await getEnabledCampList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.title,
                value: item.id,
                leaf: false,
            });
        });
        return list;
    }
    async getTermList(id) {
        let res = await getEnabledTermList(id);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.name,
                value: item.id,
                leaf: true,
            });
        });
        return list;
    }
    async getColumnList() {
        let res = await getEnabledColumnList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.columnList = res.data.data || [];
    }
    handleClickTabs(tabs) {
        console.log(tabs);
        // this.chooseType = tabs.name;
        if (tabs.name === '2') {
            if (tabs.active) {
                this.getUserExportList();
            }
            else {
                this.$message.error(`请选择${this.form.type == 1 ? '训练营' : '专栏'}`);
            }
        }
    }
    onBeforeTabs(activeName, oldActiveName) {
        // console.log(activeName,oldActiveName)
        if ((!this.form.courseId || this.form.courseId.length == 0) && activeName === '2') {
            return false;
        }
    }
    async onAddStudent() {
        if (this.form.courseId === '') {
            return this.$message.error(`请选择${this.form.type == 1 ? '训练营' : '专栏'}`);
        }
        if (this.form.keyword === '') {
            return this.$message.error(`请输入学员的${this.form.keywordType == 1 ? '手机号' : '纸条ID'}`);
        }
        let data = {
            keywordType: this.form.keywordType,
            keyword: this.form.keyword,
            courseId: this.form.type == 1 ? this.form.courseId[1] : this.form.courseId
        };
        if (this.form.source == 2) {
            data.courseId = this.form.courseId;
        }
        const res = await saveUser(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.$message({
            type: 'success',
            message: '添加成功'
        });
        this.form.keyword = '';
    }
    async getUserExportList() {
        let courseId = this.form.type == 1 ? this.form.courseId[1] : this.form.courseId;
        if (this.form.source == 2) {
            courseId = this.form.courseId;
        }
        const res = await getExportList(courseId);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.exportList = res.data.data || [];
    }
    onSuccess(res) {
        if (res.status === 200) {
            this.$message({
                type: 'success',
                message: '上传成功'
            });
            this.getUserExportList();
        }
        else {
            this.$message.error(res.msg);
        }
    }
    onDown() {
        window.open('https://course-cdn.zuowenzhitiao.com/course/courseManager/2023-02-24/学员批量导入模板.xlsx');
    }
};
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
